import React from 'react';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

import styles from './GetStarted.scss';
import ContactLink from 'Components/ContactLink';

const GetStarted = () => {
  return (
    <div className="GetStarted" id="get-started">
      <div className="GetStarted__container">
        <div className="GetStarted__left">
          <h3 className="GetStarted__header">
            <ConnectedFormattedMessage id="get_started.title" />
          </h3>
          <ContactLink type="button" />
        </div>
        <div className="GetStarted__right">
          <h5 className="GetStarted__subheader">
            <ConnectedFormattedMessage id="get_started.subtitle" />
          </h5>
          <ul className="GetStarted__list">
            <li className="GetStarted__list-item">
              <ConnectedFormattedMessage id="get_started.list_item.0" />
            </li>
            <li className="GetStarted__list-item">
              <ConnectedFormattedMessage id="get_started.list_item.1" />
            </li>
            <li className="GetStarted__list-item">
              <ConnectedFormattedMessage id="get_started.list_item.2" />
            </li>
            <li className="GetStarted__list-item">
              <ConnectedFormattedMessage id="get_started.list_item.3" />
            </li>
            <li className="GetStarted__list-item">
              <ConnectedFormattedMessage id="get_started.list_item.4" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
